import React, { Fragment } from 'react'
import aboutusimg1 from '../../Assets/Images/aboutusImg1.png'
import aboutusimg2 from '../../Assets/Images/aboutusimg2.png'
import aboutusimg3 from '../../Assets/Images/aboutusimg3.png'
import semicolon from "../../Assets/Images/semicolon.png";

const AboutDetail = ({
    section_four_content,
    section_four_heading,
    section_four_image,
    section_four_sub_heading,
    section_one_content,
    section_one_heading,
    section_one_image,
    section_three_content,
    section_three_heading,
    section_three_image,
    section_three_sub_heading,
    section_two_content,
    section_two_heading,
    section_two_image_one,
    section_two_image_two, }) => {
    return (
        <Fragment>



            <div className="container  mt-5">
                <div className="row justify-content-between  my-5">

                    <div className="col-lg-5">

                        <div className="d-flex align-items-center">

                            <div dangerouslySetInnerHTML={{ __html: section_one_heading }} />

                            <div>
                                <img src={semicolon} className='ms-4' width={"30px"} alt="" />
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: section_one_content }} />

                        <p className='text-danger'>
                            John Deacon <i><b>(owner)</b></i></p>
                    </div>

                    <div className="col-lg-5">
                        <img src={section_one_image} height={450} className='rounded-5' style={{ objectFit: "cover" }} width={"100%"} alt="" />
                    </div>
                </div>


                <div className="row justify-content-between  my-5">

                    <div className="col-lg-5">
                        <img src={section_two_image_one} height={450} className='rounded-5' style={{ objectFit: "cover" }} width={"100%"} alt="" />
                    </div>

                    <div className="col-lg-5">

                        <div className="d-flex align-items-center">

                            <div dangerouslySetInnerHTML={{ __html: section_two_heading }} />

                            <div>
                                <img src={semicolon} className='ms-4' width={"30px"} alt="" />
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: section_two_content }} />


                        <p className='text-danger'>
                            John Deacon <i><b>(owner)</b></i></p>
                    </div>


                </div>

                <div className="row justify-content-between  my-5">

                    <div className="col-lg-5">

                        <div className="d-flex align-items-center">

                            <div dangerouslySetInnerHTML={{ __html: section_three_heading }} />

                            <div>
                                <img src={semicolon} className='ms-4' width={"30px"} alt="" />
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: section_three_content }} />

                        <p className='text-danger'>
                            John Deacon <i><b>(owner)</b></i></p>
                    </div>

                    <div className="col-lg-5">
                        <img src={section_three_image} height={450} className='rounded-5' style={{ objectFit: "cover" }} width={"100%"} alt="" />
                    </div>
                </div>


                <div className="row justify-content-between  my-5">

                    <div className="col-lg-5">
                        <img src={section_four_image} height={450} className='rounded-5' style={{ objectFit: "cover" }} width={"100%"} alt="" />
                    </div>

                    <div className="col-lg-5">

                        <div className="d-flex align-items-center">

                            <div dangerouslySetInnerHTML={{ __html: section_four_heading }} />

                            <div>
                                <img src={semicolon} className='ms-4' width={"30px"} alt="" />
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: section_four_content }} />


                        <p className='text-danger'>
                            John Deacon <i><b>(owner)</b></i></p>
                    </div>


                </div>
            </div>
        </Fragment>
    )
}

export default AboutDetail